"use client"

import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"

class Kindergarten extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const CDN_URL = process.env.REACT_APP_CDN_URL

    return (
        <section className="pf-page">
          {/* PC 버전 */}
          <PC>
            <div className="kindergarten-clean-header">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={`${CDN_URL}/images/education/2.png`} alt="유치부 로고" />
                  </div>
                  <h1>유치부</h1>
                  <p>말씀의 뿌리를 내리고, 믿음의 새싹이 돋아나는 시기</p>
                </div>
              </div>
            </div>

            <div className="kindergarten-clean-content">
              <div className="content-wrapper">
                {/* 유치부 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>유치부 소개</h2>
                  </div>
                  <div className="intro-card">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-heart"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          유치부는 하나님을 알아가며 처음으로 말씀의 뿌리를 내리는 시기입니다. 예배와 놀이, 찬양과 말씀
                          교육을 통해 아이들의 마음에 복음의 씨앗이 뿌리를 내리고, 작지만 힘있는 새싹으로 자라나도록
                          돕습니다. 유치부는 아이들이 하나님의 사랑을 느끼고, 예수님을 향한 첫 사랑을 싹틔우는 시간입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 표어 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="slogan-card">
                    <div className="card-content">
                      <p className="slogan-text">하나님, 더 알고 싶어요!</p>
                    </div>
                  </div>
                </div>

                {/* 유치부 주제성구 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제 성구</h2>
                  </div>
                  <div className="verse-card">
                    <div className="card-content">
                      <p className="verse-text">
                        “그러나 너는 배우고 확신한 일에 거하라 너는 네가 누구에게서 배운 것을 알며 또 어려서부터 성경을
                        알았나니 성경은 능히 너로 하여금 그리스도 예수 안에 있는 믿음으로 말미암아 구원에 이르는 지혜가
                        있게 하느니라” (디모데후서 3:14,15)
                      </p>
                    </div>
                  </div>
                </div>

                {/* 유치부 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <p>
                          어린이들의 눈높이에 맞춘 예배를 통해 하나님을 경험하고 찬양과 율동, 성경 이야기를 통해 믿음의
                          기초를 형성합니다.
                        </p>
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>성실교회 본당 1층 유치부실</span>
                          </div>
                        </div>
                        <div className="worship-sequence">
                          <h4>예배 순서</h4>
                          <p>
                            카운트다운 - 사도신경 – 찬양 – 입례송 – 대표기도 – 말씀 – 말씀 암송 챈트 – 헌금 – 주기도문 –
                            광고 – 점심식사 - 2부순서
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육 목표</h2>
                  </div>
                  <div className="vision-grid">
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <h3>하나님의 말씀을 듣고 즐거워하며, 말씀의 기초를 마음에 심는다</h3>
                      <p>
                        아이들이 성경 이야기를 통해 하나님의 사랑을 배우고, 말씀을 암송하며 삶 속에서 실천할 수 있도록
                        돕습니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-pray"></i>
                      </div>
                      <h3>하나님이 나를 사랑하신다는 믿음을 품고, 감사와 기도를 배운다</h3>
                      <p>
                        기도하는 방법을 배우고, 감사하는 마음을 키우며, 하나님과의 개인적인 교제를 통해 믿음을
                        성장시킵니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-church"></i>
                      </div>
                      <h3>예배와 공동체 활동을 통해 교회가 좋은 곳임을 체험하며 자라난다</h3>
                      <p>
                        함께 예배드리고, 서로를 격려하며, 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을
                        심어줍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </PC>

          {/* 노트북 버전 */}
          <Notebook>
            <div className="kindergarten-clean-header">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={`${CDN_URL}/images/education/2.png`} alt="유치부 로고" />
                  </div>
                  <h1>유치부</h1>
                  <p>말씀의 뿌리를 내리고, 믿음의 새싹이 돋아나는 시기</p>
                </div>
              </div>
            </div>

            <div className="kindergarten-clean-content">
              <div className="content-wrapper">
                {/* 유치부 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>유치부 소개</h2>
                  </div>
                  <div className="intro-card">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-heart"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          유치부는 하나님을 알아가며 처음으로 말씀의 뿌리를 내리는 시기입니다. 예배와 놀이, 찬양과 말씀
                          교육을 통해 아이들의 마음에 복음의 씨앗이 뿌리를 내리고, 작지만 힘있는 새싹으로 자라나도록
                          돕습니다. 유치부는 아이들이 하나님의 사랑을 느끼고, 예수님을 향한 첫 사랑을 싹틔우는 시간입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 표어 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="slogan-card">
                    <div className="card-content">
                      <p className="slogan-text">하나님, 더 알고 싶어요!</p>
                    </div>
                  </div>
                </div>

                {/* 유치부 주제성구 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제 성구</h2>
                  </div>
                  <div className="verse-card">
                    <div className="card-content">
                      <p className="verse-text">
                        “그러나 너는 배우고 확신한 일에 거하라 너는 네가 누구에게서 배운 것을 알며 또 어려서부터 성경을
                        알았나니 성경은 능히 너로 하여금 그리스도 예수 안에 있는 믿음으로 말미암아 구원에 이르는 지혜가
                        있게 하느니라” (디모데후서 3:14,15)
                      </p>
                    </div>
                  </div>
                </div>

                {/* 유치부 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid notebook-worship">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <p>
                          어린이들의 눈높이에 맞춘 예배를 통해 하나님을 경험하고 찬양과 율동, 성경 이야기를 통해 믿음의
                          기초를 형성합니다.
                        </p>
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>성실교회 본당 1층 유치부실</span>
                          </div>
                        </div>
                        <div className="worship-sequence">
                          <h4>예배 순서</h4>
                          <p>
                            카운트다운 - 사도신경 – 찬양 – 입례송 – 대표기도 – 말씀 – 말씀 암송 챈트 – 헌금 – 주기도문 –
                            광고 – 점심식사 - 2부순서
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육 목표</h2>
                  </div>
                  <div className="vision-grid notebook-vision">
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <h3>하나님의 말씀을 듣고 즐거워하며, 말씀의 기초를 마음에 심는다</h3>
                      <p>
                        아이들이 성경 이야기를 통해 하나님의 사랑을 배우고, 말씀을 암송하며 삶 속에서 실천할 수 있도록
                        돕습니다.
                      </p>
                      <p className="vision-detail">
                        - 성경 이야기를 통해 하나님의 사랑을 배웁니다.
                        <br />- 말씀을 암송하며 삶 속에서 실천할 수 있도록 돕습니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-pray"></i>
                      </div>
                      <h3>하나님이 나를 사랑하신다는 믿음을 품고, 감사와 기도를 배운다</h3>
                      <p>
                        기도하는 방법을 배우고, 감사하는 마음을 키우며, 하나님과의 개인적인 교제를 통해 믿음을
                        성장시킵니다.
                      </p>
                      <p className="vision-detail">
                        - 기도하는 방법을 배웁니다.
                        <br />- 감사하는 마음을 키우며 하나님과의 개인적인 교제를 통해 믿음을 성장시킵니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-church"></i>
                      </div>
                      <h3>예배와 공동체 활동을 통해 교회가 좋은 곳임을 체험하며 자라난다</h3>
                      <p>
                        함께 예배드리고, 서로를 격려하며, 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을
                        심어줍니다.
                      </p>
                      <p className="vision-detail">
                        - 함께 예배드리고 서로를 격려합니다.
                        <br />- 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을 심어줍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Notebook>

          {/* 태블릿 버전 */}
          <Tablet>
            <div className="kindergarten-clean-header">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={`${CDN_URL}/images/education/2.png`} alt="유치부 로고" />
                  </div>
                  <h1>유치부</h1>
                  <p>말씀의 뿌리를 내리고, 믿음의 새싹이 돋아나는 시기</p>
                </div>
              </div>
            </div>

            <div className="kindergarten-clean-content tablet-content">
              <div className="content-wrapper">
                {/* 유치부 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>유치부 소개</h2>
                  </div>
                  <div className="intro-card tablet-intro">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-heart"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          유치부는 하나님을 알아가며 처음으로 말씀의 뿌리를 내리는 시기입니다. 예배와 놀이, 찬양과 말씀
                          교육을 통해 아이들의 마음에 복음의 씨앗이 뿌리를 내리고, 작지만 힘있는 새싹으로 자라나도록
                          돕습니다. 유치부는 아이들이 하나님의 사랑을 느끼고, 예수님을 향한 첫 사랑을 싹틔우는 시간입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 표어 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="slogan-card">
                    <div className="card-content">
                      <p className="slogan-text">하나님, 더 알고 싶어요!</p>
                    </div>
                  </div>
                </div>

                {/* 유치부 주제성구 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제 성구</h2>
                  </div>
                  <div className="verse-card">
                    <div className="card-content">
                      <p className="verse-text">
                        “그러나 너는 배우고 확신한 일에 거하라 너는 네가 누구에게서 배운 것을 알며 또 어려서부터 성경을
                        알았나니 성경은 능히 너로 하여금 그리스도 예수 안에 있는 믿음으로 말미암아 구원에 이르는 지혜가
                        있게 하느니라” (디모데후서 3:14,15)
                      </p>
                    </div>
                  </div>
                </div>

                {/* 유치부 예배 안내 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid tablet-worship">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <p>
                          어린이들의 눈높이에 맞춘 예배를 통해 하나님을 경험하고 찬양과 율동, 성경 이야기를 통해 믿음의
                          기초를 형성합니다.
                        </p>
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>성실교회 본당 1층 유치부실</span>
                          </div>
                        </div>
                        <div className="worship-sequence">
                          <h4>예배 순서</h4>
                          <p>
                            카운트다운 - 사도신경 – 찬양 – 입례송 – 대표기도 – 말씀 – 말씀 암송 챈트 – 헌금 – 주기도문 –
                            광고 – 점심식사 - 2부순서
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육 목표</h2>
                  </div>
                  <div className="vision-grid tablet-vision">
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <h3>하나님의 말씀을 듣고 즐거워하며, 말씀의 기초를 마음에 심는다</h3>
                      <p>
                        아이들이 성경 이야기를 통해 하나님의 사랑을 배우고, 말씀을 암송하며 삶 속에서 실천할 수 있도록
                        돕습니다.
                      </p>
                      <p className="vision-detail">
                        - 성경 이야기를 통해 하나님의 사랑을 배웁니다.
                        <br />- 말씀을 암송하며 삶 속에서 실천할 수 있도록 돕습니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-pray"></i>
                      </div>
                      <h3>하나님이 나를 사랑하신다는 믿음을 품고, 감사와 기도를 배운다</h3>
                      <p>
                        기도하는 방법을 배우고, 감사하는 마음을 키우며, 하나님과의 개인적인 교제를 통해 믿음을
                        성장시킵니다.
                      </p>
                      <p className="vision-detail">
                        - 기도하는 방법을 배웁니다.
                        <br />- 감사하는 마음을 키우며 하나님과의 개인적인 교제를 통해 믿음을 성장시킵니다.
                      </p>
                    </div>
                    <div className="vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-church"></i>
                      </div>
                      <h3>예배와 공동체 활동을 통해 교회가 좋은 곳임을 체험하며 자라난다</h3>
                      <p>
                        함께 예배드리고, 서로를 격려하며, 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을
                        심어줍니다.
                      </p>
                      <p className="vision-detail">
                        - 함께 예배드리고 서로를 격려합니다.
                        <br />- 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을 심어줍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tablet>

          {/* 모바일 버전 */}
          <Mobile>
            <div className="kindergarten-clean-header">
              <div className="header-container">
                <div className="header-content">
                  <div className="header-icon">
                    <img src={`${CDN_URL}/images/education/2.png`} alt="유치부 로고" />
                  </div>
                  <h1>유치부</h1>
                  <p>말씀의 뿌리를 내리고, 믿음의 새싹이 돋아나는 시기</p>
                </div>
              </div>
            </div>

            <div className="kindergarten-clean-content mobile-content">
              <div className="content-wrapper">
                {/* 유치부 소개 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>유치부 소개</h2>
                  </div>
                  <div className="intro-card mobile-intro">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <i className="fas fa-heart"></i>
                      </div>
                      <div className="text-content">
                        <p className="main-text">
                          유치부는 하나님을 알아가며 처음으로 말씀의 뿌리를 내리는 시기입니다. 예배와 놀이, 찬양과 말씀
                          교육을 통해 아이들의 마음에 복음의 씨앗이 뿌리를 내리고, 작지만 힘있는 새싹으로 자라나도록
                          돕습니다. 유치부는 아이들이 하나님의 사랑을 느끼고, 예수님을 향한 첫 사랑을 싹틔우는 시간입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 표어 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>표어</h2>
                  </div>
                  <div className="slogan-card">
                    <div className="card-content">
                      <p className="slogan-text">하나님, 더 알고 싶어요!</p>
                    </div>
                  </div>
                </div>

                {/* 유치부 주제성구 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>주제 성구</h2>
                  </div>
                  <div className="verse-card">
                    <div className="card-content">
                      <p className="verse-text">
                        “그러나 너는 배우고 확신한 일에 거하라 너는 네가 누구에게서 배운 것을 알며 또 어려서부터 성경을
                        알았나니 성경은 능히 너로 하여금 그리스도 예수 안에 있는 믿음으로 말미암아 구원에 이르는 지혜가
                        있게 하느니라” (디모데후서 3:14,15)
                      </p>
                    </div>
                  </div>
                </div>

                {/* 유치부 예배 안내 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid mobile-worship">
                    <div className="worship-card mobile-worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <i className="fas fa-church"></i>
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <p>
                          어린이들의 눈높이에 맞춘 예배를 통해 하나님을 경험하고 찬양과 율동, 성경 이야기를 통해 믿음의
                          기초를 형성합니다.
                        </p>
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>성실교회 본당 1층 유치부실</span>
                          </div>
                        </div>
                        <div className="worship-sequence">
                          <h4>예배 순서</h4>
                          <p>
                            카운트다운 - 사도신경 – 찬양 – 입례송 – 대표기도 – 말씀 – 말씀 암송 챈트 – 헌금 – 주기도문 –
                            광고 – 점심식사 - 2부순서
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 유치부 교육목표 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>교육 목표</h2>
                  </div>
                  <div className="vision-grid mobile-vision">
                    <div className="vision-card mobile-vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <h3>하나님의 말씀을 듣고 즐거워하며, 말씀의 기초를 마음에 심는다</h3>
                      <p>
                        아이들이 성경 이야기를 통해 하나님의 사랑을 배우고, 말씀을 암송하며 삶 속에서 실천할 수 있도록
                        돕습니다.
                      </p>
                      <p className="vision-detail">
                        - 성경 이야기를 통해 하나님의 사랑을 배웁니다.
                        <br />- 말씀을 암송하며 삶 속에서 실천할 수 있도록 돕습니다.
                      </p>
                    </div>
                    <div className="vision-card mobile-vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-pray"></i>
                      </div>
                      <h3>하나님이 나를 사랑하신다는 믿음을 품고, 감사와 기도를 배운다</h3>
                      <p>
                        기도하는 방법을 배우고, 감사하는 마음을 키우며, 하나님과의 개인적인 교제를 통해 믿음을
                        성장시킵니다.
                      </p>
                      <p className="vision-detail">
                        - 기도하는 방법을 배웁니다.
                        <br />- 감사하는 마음을 키우며 하나님과의 개인적인 교제를 통해 믿음을 성장시킵니다.
                      </p>
                    </div>
                    <div className="vision-card mobile-vision-card">
                      <div className="vision-icon">
                        <i className="fas fa-church"></i>
                      </div>
                      <h3>예배와 공동체 활동을 통해 교회가 좋은 곳임을 체험하며 자라난다</h3>
                      <p>
                        함께 예배드리고, 서로를 격려하며, 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을
                        심어줍니다.
                      </p>
                      <p className="vision-detail">
                        - 함께 예배드리고 서로를 격려합니다.
                        <br />- 사랑을 나누는 공동체 활동을 통해 교회에 대한 긍정적인 인식을 심어줍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Mobile>
        </section>
    )
  }
}

export default Kindergarten
